// Snellife hero: parole a rotazione, parallasse delle card e faretto che segue il mouse.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.querySelectorAll('[data-snl-hero]').forEach((hero) => {
    const track = hero.querySelector('[data-snl-words]');
    if (track && !reduceMotion && track.children.length > 2) {
      const total = track.children.length;
      let index = 0;

      setInterval(() => {
        index += 1;
        track.style.transition = 'transform 0.6s cubic-bezier(0.7, 0, 0.3, 1)';
        track.style.transform = `translateY(${(-index * 100) / total}%)`;

        // L'ultima parola è una copia della prima: torna all'inizio senza animazione
        if (index === total - 1) {
          setTimeout(() => {
            track.style.transition = 'none';
            track.style.transform = 'translateY(0)';
            index = 0;
          }, 650);
        }
      }, 2600);
    }

    // Anello rotante e nastro sono animazioni infinite: in pausa quando non sono sullo schermo
    const loops = hero.querySelectorAll('.snl-hero__ring, .snl-hero__marquee-track');
    if (loops.length && 'IntersectionObserver' in window) {
      const loopObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      });
      loops.forEach((loop) => loopObserver.observe(loop));
    }

    if (reduceMotion || !finePointer) return;

    let frame = null;
    hero.addEventListener('pointermove', (event) => {
      const bounds = hero.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width;
      const y = (event.clientY - bounds.top) / bounds.height;

      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        hero.style.setProperty('--mx', ((x - 0.5) * 2).toFixed(3));
        hero.style.setProperty('--my', ((y - 0.5) * 2).toFixed(3));
        hero.style.setProperty('--sx', `${(x * 100).toFixed(1)}%`);
        hero.style.setProperty('--sy', `${(y * 100).toFixed(1)}%`);
      });
    });

    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--mx', 0);
      hero.style.setProperty('--my', 0);
    });
  });
})();
